import { useMutation } from '@tanstack/react-query'

import { addComment } from '@src/api'
import { DefaultApiAddCommentRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useAddComment = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiAddCommentRequest) =>
      addComment(axiosInstance, params),
  })
}
